/**
 * -- MAIN.JS --
 * This file is the main entry point for Vite.
 * It imports the main SCSS file for all compiled CSS.
 * This theme also includes AlpineJS and HTMX.
 */

import 'vite/modulepreload-polyfill';
import './styles/main.scss';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import htmx from 'htmx.org';
import motionPlugin from './js/motion-alpine';
import { run, choreography } from './js/motion-choreography';

// Alpine JS
Alpine.plugin(collapse);
// Motion system — registers x-motion directive + $motion magic (Tier 3)
Alpine.plugin(motionPlugin({ run, choreography }));
import './js/alpine-stores';
import './js/alpine-components/directory';
import './js/alpine-components/gallery';
import './js/alpine-components/news-archive';
import './js/alpine-components/news-carousel';
import './js/alpine-components/event-related-slider';
import './js/alpine-components/past-walks';
import './js/alpine-components/event-listing';
import './js/alpine-components/google-map';
import './js/alpine-components/entity-map';
import './js/alpine-components/nav-dropdown';
import './js/alpine-components/loader';
window.Alpine = Alpine;
Alpine.start();

// Motion system — decoupled data-motion path (vanilla, self-initializing)
import './js/motion-init';

// Lenis smooth scrolling, site-wide (self-initializing; exposes window.lenis)
import './js/smooth-scroll';

// Parallax gallery
import './js/parallax-gallery';

// Lazy, motion-aware hero background video
import './js/hero-video';

// Animate the hero clip-mask reshape across the desktop/mobile breakpoint
import './js/hero-mask';

// Randomize the hero-collage side images on load
import './js/hero-collage';

// HTMX
window.htmx = htmx;

// Testing
document.addEventListener('DOMContentLoaded', () => {
  console.log('Vite files loaded');
});
